import Chapter from "./Chapter";
import { motion } from "framer-motion";
import { PlayCircle } from "lucide-react";
import { VIDEOS, ASSETS } from "./assets";

export default function VideoShowcase() {
  return (
    <section id="video" data-testid="video-section" className="py-24 lg:py-32 bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <Chapter index={3} label="Démonstration vidéo" />
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            Sapeur-360 en action.
          </h2>
          <p className="mt-4 text-lg text-white/60">
            Découvrez la plateforme sur le terrain : du levage d'un véhicule à l'extinction d'un
            incendie.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.src}
              data-testid={`video-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="border border-white/10 rounded-sm overflow-hidden bg-black"
            >
              <div className="relative aspect-video bg-black">
                <video
                  data-testid={`video-player-${i}`}
                  src={v.src}
                  poster={v.poster}
                  controls
                  playsInline
                  preload="metadata"
                  muted
                  loop
                  className="absolute inset-0 h-full w-full object-contain bg-black"
                />
                {/* Brand watermark (Option B) */}
                <div className="pointer-events-none absolute top-2.5 right-2.5 z-10 flex items-center gap-1.5 bg-white/95 rounded-sm px-2 py-1 shadow-sm">
                  <img src={ASSETS.logo} alt="Sapeur-360" className="h-5 w-5 object-contain" />
                  <span className="font-display text-[11px] font-extrabold tracking-tight text-[#0A0A0A] leading-none">
                    Sapeur<span className="text-[#E63946]">-360</span>
                  </span>
                </div>
              </div>
              <figcaption className="p-6 border-t border-white/10">
                <div className="flex items-center gap-2.5">
                  <PlayCircle className="h-5 w-5 text-[#E63946]" />
                  <h3 className="font-display text-lg font-bold tracking-tight">{v.title}</h3>
                </div>
                <p className="mt-2 text-white/60 leading-relaxed">{v.desc}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
